import React, { useCallback } from 'react';

import { Control } from '@vlabs/uikit';
import { useFormContext, useWatch } from 'react-hook-form';

import { useUpdateField } from '../hooks';

export function ExtractFaceDescriptorToggle() {
  const { control } = useFormContext();
  const estimateFace = useWatch({ name: 'estimate.face' });
  const extractFaceDescriptor = useWatch({ name: 'extract.faceDescriptor' });

  useUpdateField({
    path: 'matchPolicy',
    value: [],
    on: useCallback(() => extractFaceDescriptor === false, [extractFaceDescriptor]),
    updateIf: useCallback(
      (currentValue) => currentValue?.length > 0,
      [],
    ),
  });

  return (
    <Control.Switch
      control={control}
      disabled={!estimateFace}
      name="extract.faceDescriptor"
    />
  );
}
